<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppHeader from '@/components/app/AppHeader.vue'
import { OptionsSnackbar } from '@haskoning/vue-component-library'
import { nextTick, provide, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthenticationStore } from '@/stores/authentication'

const authStore = useAuthenticationStore()

const appbar = ref<InstanceType<typeof AppHeader> | null>(null)
const appHeaderHeight = ref(0)
provide('appHeaderHeight', appHeaderHeight)

const { user } = storeToRefs(authStore)

watch(
	() => user.value,
	async (val) => {
		if (val) {
			await nextTick()
			appHeaderHeight.value = appbar.value?.$el?.offsetHeight || 0
		}
	}
)
</script>

<template>
	<v-app>
		<AppHeader ref="appbar"></AppHeader>
		<v-main>
			<RouterView />
		</v-main>
		<OptionsSnackbar
			style="z-index: 3000"
			:excluded-http-methods="['GET', 'OPTIONS', 'PATCH']"
		></OptionsSnackbar>
	</v-app>
</template>
<style lang="scss">
// the main file that imports everything related with styles
@use '/src/scss/settings.scss';
</style>
